import React, { useState } from 'react';
import { BookOpen, PhoneCall } from 'lucide-react';
import { MagicCard } from './magicui/MagicCard';

const MENTORS_GRID = [
  { id: 1, category: 'Chemistry', title: 'Grade 11 & 12 Chemistry Lead', mentor: 'Kian (McMaster Neuroscience Scholar)', desc: 'Stoichiometry, thermodynamics, and organic chemistry drill mastery.' },
  { id: 2, category: 'Math', title: 'Functions & Calculus Specialist', mentor: 'Math & Physics Scholar', desc: 'Step-by-step calculus proofs, vectors, and advanced functions optimization.' },
  { id: 3, category: 'SAT', title: 'SAT & Entrance Exam Lead', mentor: 'Kian + English Scholar', desc: 'Standardized test strategy, quantitative reasoning, and speed drills.' },
  { id: 4, category: 'Pre-Law', title: 'Pre-Law & Rhetoric Specialist', mentor: 'Academic Rhetoric Scholar', desc: 'Argumentative essay structure, formal logic, and literary analysis.' }
];

export function SubjectOfferings() {
  const [filter, setFilter] = useState('All');

  const filtered = filter === 'All' ? MENTORS_GRID : MENTORS_GRID.filter(m => m.category === filter);

  return (
    <section id="mentors" className="py-16 space-y-8">
      <div className="text-center space-y-3">
        <span className="text-xs font-semibold text-amber-600 dark:text-amber-400 uppercase tracking-widest">
          Specialized Mentors Network
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
          Academic Subject Mastery Tracks
        </h2>
        <p className="text-slate-600 dark:text-slate-400 text-sm max-w-xl mx-auto">
          Filter our specialized mentor tracks or speak directly with Kian for custom pairing.
        </p>
      </div>

      {/* Filter Tabs */}
      <div className="flex flex-wrap items-center justify-center gap-2">
        {['All', 'Chemistry', 'Math', 'SAT', 'Pre-Law'].map((cat) => (
          <button
            key={cat}
            onClick={() => setFilter(cat)}
            className={`px-4 py-2 rounded-xl text-xs font-semibold transition ${
              filter === cat
                ? 'bg-amber-500 text-slate-950 shadow-md shadow-amber-500/20'
                : 'border border-slate-200 bg-white text-slate-700 hover:border-slate-300 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-slate-700'
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {filtered.length > 0 ? (
          filtered.map((item) => (
            <MagicCard key={item.id}>
              <div className="space-y-3">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/10 text-amber-800 dark:text-amber-300 text-xs font-semibold">
                  <BookOpen className="h-3.5 w-3.5" /> {item.category}
                </div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white">{item.title}</h3>
                <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{item.desc}</p>
                <div className="text-xs font-semibold text-amber-600 dark:text-amber-400 pt-2">Lead: {item.mentor}</div>
              </div>
            </MagicCard>
          ))
        ) : (
          /* Empty State Fallback */
          <div className="col-span-full p-8 rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60 text-center space-y-4 shadow-sm dark:shadow-none">
            <p className="text-slate-700 dark:text-slate-300 text-sm">No specialized mentors found for this filter.</p>
            <a href="tel:+14374382820" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-amber-500 text-slate-950 font-bold text-sm">
              <PhoneCall className="h-4 w-4" /> Call Kian for Custom Matching: +1 (437) 438-2820
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
